import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Calendar from './pages/Calendar';
import Stats from './pages/Stats';
import Search from './pages/Search';
import NotFound from './pages/NotFound';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import InstallPrompt from './components/InstallPrompt';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen bg-gray-100">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/calendar"
              element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <Calendar />
                  </>
                </PrivateRoute>
              }
            />
            <Route
              path="/stats"
              element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <Stats />
                  </>
                </PrivateRoute>
              }
            />
            <Route
              path="/search"
              element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <Search />
                  </>
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/calendar" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <InstallPrompt />
        </div>
        <Toaster position="top-right" />
      </AuthProvider>
    </Router>
  );
}

export default App;